<div class="sidenav-header">
  <img class="avatar" [src]="avatar|async"/>
  <p class="h7 user-name">{{(user | async)?.first_name}} {{(user | async)?.last_name}}</p>
  @if (((accounts|async)?.length || 0)>1) {
    <p mat-menu-item class="mat-subtitle-2 unit-name" [matMenuTriggerFor]="units">
      <span class="unit-name_title">
        <span>{{(currentAccount|async)?.title}} </span>
        <span> {{(currentAccount|async)?.title_line_2}}</span>
      </span>
      @if (((accounts|async)?.length || 0) > 1) {
        <mat-icon class="unit-name_expand" [inline]="true">expand_more</mat-icon>
      }
    </p>
  }
  @if ((accounts|async)?.length === 1) {
    <p class="mat-subtitle-2 unit-name">
      <span class="unit-name_title">
        <span>{{(currentAccount|async)?.title}}</span>
        <span>{{(currentAccount|async)?.title_line_2}}</span>
      </span>
    </p>
  }
</div>
<div class="divider-container">
  <mat-divider></mat-divider>
</div>

<mat-nav-list>
  <a mat-list-item routerLink="/profile">
    <span class="mat-subtitle-2">
      <span class="mat-icon-container mat-icon-container-no-background">
        <mat-icon svgIcon="pq:user_profile"></mat-icon>
      </span>
      {{'My profile' | translate}}
    </span>
  </a>
  <a mat-list-item href="https://payquad.com/support-centre/" target="_blank" appOpenInAppBrowser>
    <span class="mat-subtitle-2">
      <span class="mat-icon-container mat-icon-container-no-background">
        <mat-icon svgIcon="pq:home_house_message_chat"></mat-icon>
      </span>
      {{'Help Center' | translate}}
    </span>
  </a>
  <!--    <a mat-list-item>-->
  <!--          <span class="mat-body-2">-->
  <!--            <div class="mat-icon-container mat-icon-container-no-background">-->
  <!--              <mat-icon svgIcon="pq:settings_round"></mat-icon>-->
<!--            </div>-->
<!--              {{'Settings & Preferences' | translate}}-->
<!--          </span>-->
<!--    </a>-->
@if (customization.config|async; as c) {
  @if (c.website) {
    <a mat-list-item [href]="c.website" target="_blank" appOpenInAppBrowser>
      <span class="mat-subtitle-2">
        <span class="mat-icon-container mat-icon-container-no-background">
          <mat-icon svgIcon="pq:earth_cursor_select"></mat-icon>
        </span>
        {{c.name}} Website
      </span>
    </a>
  }
}
<a mat-list-item (click)="signOut()">
  <span class="mat-subtitle-2">
    <span class="mat-icon-container mat-icon-container-no-background">
      <mat-icon svgIcon="pq:login_logout_arrow"></mat-icon>
    </span>
    {{'Sign Out' | translate}}
  </span>
</a>
</mat-nav-list>

<mat-menu #units="matMenu" class="pq-menu pq-menu-center main-navigation-menu sidenav-profile-unit-menu" xPosition="before">
  <div class="triangle"></div>
  <div class="menu-scroll-container">
  @for (a of (accounts|async); track a) {
    @if (a.id !== (user|async)?.id && a.title) {
      <button mat-menu-item (click)="switchUser(a.id)">
        <span class="mat-icon-container">
          <mat-icon matPrefix svgIcon="pq:modern-building" color="primary"></mat-icon>
        </span>
        <span>{{a.title}}<br> {{a.title_line_2}}</span>
      </button>
    }
    @if (a.permissions==='applicant') {
      <a (click)="goLeasingPortal()" mat-menu-item>
        <span>Applicant: {{a.first_name}} {{a.last_name}}</span>
        <mat-icon matPrefix svgIcon="pq:documents_file_text" color="primary"></mat-icon>
      </a>
    }
  }
  </div>
</mat-menu>
